import React, { ReactElement, useEffect } from 'react';
import { LoginForm } from '../../features/auth/LoginForm';
import { useUILogic } from '../../shared/providers/UILogicProvider/hooks';

function Content(): ReactElement {
  const { authorizationUiModule } = useUILogic();

  useEffect(() => {
    authorizationUiModule.trySessionLogin();
  }, []);

  return <LoginForm />;
}

export { Content };
